import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getSubNavUsers: () => NavRoute = () => ({
	name: getName()
	, security: security => security.coreFeatures
    , href: 'users'
	, children: getUserAreas()
    , isSubNav: true
});

function getName() : string {
	let name: string;
	let url = globalThis.location.href;
	
	if (
		url.includes('users/edit/details/')
		|| url.includes('users/edit/associate-sites/')
		|| url.includes('users/edit/security/')
		|| url.includes('users/edit/mou/')
		|| url.includes('users/edit/notifications/')
		|| url.includes('users/edit/audit-history/')
		|| url.includes('users/edit/login-history/')
	) { name = "Edit User"; } 
	else { name = "Users"; }

	return name;
}

function getUserAreas() : NavRoute[] {
	let id: string = "";
	let url = globalThis.location.href;

	if (url.includes('users/edit/details/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('users/edit/associate-sites/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('users/edit/security/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('users/edit/mou/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('users/edit/notifications/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('users/edit/audit-history/')) { id = url.substring(url.lastIndexOf('/') + 1); }
	if (url.includes('users/edit/login-history/')) { id = url.substring(url.lastIndexOf('/') + 1); }

	// Users List and Global Login History
	if (id === "") { 
		return [
			{
				name: 'List'
				, exact: true
				, path: 'users/list'
                , activeNavLink: 'users/list'
				, secondaryNav: ['Users', 'List']
			}
            , {
				name: 'Login History'
				, exact: true
				, path: 'users/login-history'
                , activeNavLink: 'users/login-history'
				, secondaryNav: ['Users', 'Login History']
			}
		]; 
	}

	// Creating a new User
	if (id === "0") {
		return [
			{
				name: 'Back'
				, exact: true
				, path: `users/list`
			}
            , {
				name: 'Details'
				, exact: true
				, path: `users/edit/details/${id}`
                , activeNavLink: 'users/edit/details'
				, secondaryNav: ['Users', 'Edit User', 'Details']
			}
		];
	}

	if (id.includes("isCreatingNewUser"))
		return [
			{
				name: 'Back'
				, exact: true
				, path: `users/list`
			}
            , {
				name: 'Details'
				, exact: true
				, path: `users/edit/details/${id}`
                , activeNavLink: 'users/edit/details'
			    , secondaryNav: ['Users', 'Edit User', 'Details']
			}
            , {
				name: 'Associate Sites'
				, exact: true
				, path: `users/edit/associate-sites/${id}?isCreatingNewUser=true`
				, security: security => security.manageSiteUsers
                , activeNavLink: 'users/edit/associate-sites'
			    , secondaryNav: ['Users', 'Edit User', 'Associate Sites']
			}
		]

	// User details
	return [
		{
			name: 'Back'
			, exact: true
			, path: `users/list`
		}
        , {
			name: 'Details'
			, exact: true
			, path: `users/edit/details/${id}`
            , activeNavLink: 'users/edit/details'
			, secondaryNav: ['Users', 'Edit User', 'Details']
		}
        , {
			name: 'Associate Sites'
			, exact: true
			, path: `users/edit/associate-sites/${id}`
			, security: security => security.manageSiteUsers
            , activeNavLink: 'users/edit/associate-sites'
			, secondaryNav: ['Users', 'Edit User', 'Associate Sites']
		}
        , {
			name: 'Security'
			, exact: true
			, path: `users/edit/security/${id}`
            , activeNavLink: 'users/edit/security'
			, secondaryNav: ['Users', 'Edit User', 'Security']
		}
        , {
			name: 'MOU'
			, exact: true
			, path: `users/edit/mou/${id}`
            , activeNavLink: 'users/edit/mou'
			, secondaryNav: ['Users', 'Edit User', 'MOU']
		}
        , {
			name: 'Login History'
			, exact: true
			, path: `users/edit/login-history/${id}`
            , activeNavLink: 'users/edit/login-history'
			, secondaryNav: ['Users', 'Edit User', 'Login History']
		}
        , {
			name: 'Audit History'
			, exact: true
			, path: `users/edit/audit-history/${id}`
			, security: security => security.manageSiteUsers
            , activeNavLink: 'users/edit/audit-history'
			, secondaryNav: ['Users', 'Edit User', 'Audit History']
		}
        , {
			name: 'Notifications'
			, exact: true
			, path: `users/edit/notifications/${id}`
            , activeNavLink: 'users/edit/notifications'
			, secondaryNav: ['Users', 'Edit User', 'Notifications']
		}
	];
}